import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'neo-clear-storage',
  template: `
    <div style="padding: 20px; text-align: center;">
      <h1>Storage Cleared!</h1>
      <p>All MSAL and browser storage has been cleared.</p>
      <p>Click the button below to reload the app.</p>
      <button (click)="reload()" style="padding: 10px 20px; font-size: 16px; cursor: pointer;">
        Reload Application
      </button>
    </div>
  `,
  standalone: true
})
export class ClearStorageComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Clear all storage
    this.clearAllStorage();
  }

  private clearAllStorage(): void {
    try {
      // Clear localStorage
      const localKeys = Object.keys(localStorage);
      localKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      // Clear sessionStorage
      const sessionKeys = Object.keys(sessionStorage);
      sessionKeys.forEach(key => {
        sessionStorage.removeItem(key);
      });
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  }

  reload(): void {
    // Force reload without cache
    window.location.href = window.location.origin;
  }
}
